import axios from "axios";

export type RestRequestInit = {
  method?: "GET" | "POST" | "PUT" | "PATCH" | "DELETE";
  body?: unknown;
  headers?: Record<string, string>;
};

const httpClient = axios.create({
  withCredentials: false,
  headers: { Accept: "application/json" },
});

export async function restJson<T>(path: string, init: RestRequestInit = {}): Promise<T> {
  const { method = "GET", body, headers } = init;
  const { data } = await httpClient.request<T>({
    url: path,
    method,
    data: body,
    headers,
  });
  return data;
}
